// key
export const encryptedKey = '%$houseKeeping$%';

// encrypt 
export const crypt = (textData) => {
    let text = textData?.toString()
    const textToChars = (text) => text?.split("")?.map((c) => c?.charCodeAt(0));
    const byteHex = (n) => ("0" + Number(n)?.toString(16)).substr(-2);
    const applySaltToChar = (code) => textToChars(encryptedKey)?.reduce((a, b) => a ^ b, code);

    return text
        ?.split("")
        ?.map(textToChars)
        ?.map(applySaltToChar)
        ?.map(byteHex)
        ?.join("");
};

// decrypt
export const decrypt = (encoded) => {
    let textData = encoded.toString()
    const textToChars = (text) => text?.split("")?.map((c) => c?.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(encryptedKey)?.reduce((a, b) => a ^ b, code);
    return textData
        ?.match(/.{1,2}/g)
        ?.map((hex) => parseInt(hex, 16))
        ?.map(applySaltToChar)
        ?.map((charCode) => String.fromCharCode(charCode))
        ?.join("");
};

export function hasDifferentRoleOrProperty(data) {
    const roles = new Set();
    const properties = new Set();

    data?.forEach(record => {
        roles.add(record?.roles_id);
        properties.add(record?.properties_id);
    });

    return (roles.size > 1 || properties.size > 1) ? 'true' : 'false';
}
export function hasMultipleRoles(data) {
    const roleIds = new Set(data?.map(item => item?.roles_id));
    return roleIds?.size > 1;
}

// Function to check if there are multiple properties or a single property
export function hasMultipleProperties(data) {
    const propertyIds = new Set(data?.map(item => item?.properties_id));
    return propertyIds?.size > 1;
}

// Function to return an array of unique roles with {value, label}
export function getRolesArray(data) {
    const roles = new Map();

    data?.forEach(record => {
        if (!roles?.has(record?.roles_id)) {
            roles.set(record.roles_id, {
                ...record,
                value: record.roles_id,
                label: record.role_name,
            });
        }
    });

    return Array.from(roles.values());
}

// format elapsed time to format `00:00:00`
export const formatElapsedTime = (elapsed) => {
    if (elapsed) {
        const hours = String(elapsed.getUTCHours()).padStart(2, '0');
        const minutes = String(elapsed.getUTCMinutes()).padStart(2, '0');
        const seconds = String(elapsed.getUTCSeconds()).padStart(2, '0');
        const formattedTime = `${hours}:${minutes}:${seconds}`;
        return formattedTime
    } else return `00:00:00`
}
export const timeRemoveSecs = (time) => {
    if (time) {
        const [hours, minutes] = time?.split(':')
        const formattedTime = `${hours}:${minutes}`;
        return formattedTime
    } else return `00:00`
}

// time to Seconds
export const parseTimeToSeconds = (timeStr) => {
    if (timeStr === '00:00:00') {
        return 0
    } else {
        const [hours, minutes, seconds] = timeStr?.split(':')?.map(Number);
        return hours * 3600 + minutes * 60 + seconds;
    }
};

// time to h:m:s am/pm
export const formatTime = (timeStr) => {
    if (timeStr) {
        let [hours, minutes, seconds] = timeStr?.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${minutes}:${seconds} ${ampm}`;
    }
    else {
        return
    }
};
export const formatTimeTillMin = (timeStr) => {
    if (timeStr) {
        let [hours, minutes] = timeStr?.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${ampm}`;
    }
    else {
        return
    }
};
// secs to `00:00:00` format
export function formatTimeStr(seconds) {
    if (seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else { return '00:00:00' }
}

export function countCompleteEvents(scheduleData) {
    const eventPrefixes = [
        'cartPrep',
        'rooms_cleaning_1',
        'break1',
        'rooms_cleaning_2',
        'lunch',
        'rooms_cleaning_3',
        'break2',
        'rooms_cleaning_4',
        'wrap'
    ];

    let count = 0;

    for (const prefix of eventPrefixes) {
        const inKey = `${prefix}In`;
        const outKey = `${prefix}Out`;

        if (scheduleData[inKey] !== null && scheduleData[outKey] !== null &&
            scheduleData[inKey] !== undefined && scheduleData[outKey] !== undefined) {
            count++;
        }
    }

    return count;
}
export const getFilteredModifiedData = (shiftData) => {
    const modifiedShiftData = Object.fromEntries(
        Object.entries(shiftData).filter(([key, value]) => key.endsWith('In') || key.endsWith('Out'))
    );

    return modifiedShiftData
}

export function generateShiftData(shiftData) {
    if (shiftData?.length > 0) {

        let segments = shiftData?.map(e => e?.segment_name)
        let data = {};

        shiftData?.forEach(item => {
            const keyPrefix = segments[item.segment_name] ? segments[item.segment_name] : item.segment_name?.replaceAll(' ', '_');
            if (keyPrefix) {
                data[`${keyPrefix}Start`] = item.time_start_decimal //time_start?.split(' ')?.[1]?.substring(0, 5)?.replace(':', '.');
                data[`${keyPrefix}End`] = item.time_end_decimal //time_end?.split(' ')?.[1]?.substring(0, 5)?.replace(':', '.');
                data[`${keyPrefix}In`] = item.time_in_decimal
                data[`${keyPrefix}Out`] = item.time_out_decimal
                data[`${keyPrefix}Color`] = item.color_code === '#ffffff' ? '#E0346F' : item.color_code
            }
        });
        return data;
    } else {
        return {};
    }
}


export function divideRange(arrayData, minData, maxData, indexCount) {
    // Helper function to format numbers
    const formatNumber = (num) => {
        return Number.isInteger(num) ? num : Number(num.toFixed(1));
    };

    // Ensure we have at least one value in the array
    if (!arrayData || arrayData.length === 0) {
        return Array(indexCount ? indexCount : 25).fill(0); // Return an array of 25 zeros if no data
    }

    // Convert all inputs to numbers and format appropriately
    let max = formatNumber(Number(maxData));
    let min = formatNumber(Number(minData));
    // let array = arrayData.map(e => formatNumber(Number(e)));

    // If min and max are the same, create a range around this value
    if (min === max) {
        min = formatNumber(min - 5);
        max = formatNumber(max + 5);
    }

    // Determine the range
    let range = max - min;

    // Calculate the step size for 25 segments
    const stepSize = range / 24;

    // Generate 25 equally spaced values
    const dividedValues = Array.from({ length: indexCount ? indexCount : 25 }, (_, i) => {
        return formatNumber(min + i * stepSize);
    });

    return dividedValues;
}


// Function to store unique properties
export function storeUniqueProperties(data) {
    const uniqueProperties = [];
    const propertySet = new Set();

    data.forEach(item => {
        const propertyKey = `${item.properties_id}-${item.property_name}`;
        if (!propertySet.has(propertyKey)) {
            propertySet.add(propertyKey);
            uniqueProperties.push(item);
        }
    });

    return uniqueProperties;
}

export const getPropertiesData = (userData) => {
    let properties_roles = userData?.user_info?.properties_roles_array ? Array.isArray(userData?.user_info?.properties_roles_array) ? userData?.user_info?.properties_roles_array : [userData?.user_info?.properties_roles_array] : userData?.user_info?.properties_roles_array
    return properties_roles
}
export const getUserDetailsAll = (userData) => {
    let userDetailsAllData = {
        ...userData,
        user_info: {
            ...userData?.user_info,
            properties_id: userData?.session_info?.properties_id
        },
        schedule_info: {
            ...userData?.schedule_info,
            schedule_details: {
                ...userData?.schedule_info?.schedule_details,
                tcs_id_active: userData?.session_info?.tcs_id_active,
                ss_is_out: userData?.session_info?.ss_id_active,
                current_segment_name: userData?.session_info?.segment_name_active ? userData?.session_info?.segment_name_active : null
            }
        }
    }
    return userDetailsAllData
}

export const getBackgroundColor = ((segment_name) => {
    switch (segment_name) {
        case 'cart prep':
        case 'cart wrap':
            return '#F8D495';
        case 'rooms cleaning 1':
        case 'rooms cleaning 2':
        case 'rooms cleaning 3':
        case 'rooms cleaning 4':
            return '#A9DCE3';
        case 'break1':
        case 'break2':
            return '#BD9DCB';
        case 'lunch':
            return '#e0346fbf';
        default:
            return 'white'; // Default color
    }
})

export function calculateTimeDifference(timeOut, timeIn) {
    if (timeOut && timeIn) {
        // Parse the timestamps to Date objects
        const timeOutDate = new Date(timeOut);
        const timeInDate = new Date(timeIn);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = timeInDate - timeOutDate;

        // Convert milliseconds to seconds
        const differenceInSeconds = differenceInMilliseconds / 1000;

        return differenceInSeconds;
    } else return '-'
}

export const dateToUnix = (dateString) => {
    if (dateString) {
        const date = new Date(dateString?.replace(/-/g, '/')); // Replace dashes for compatibility if needed
        const unixTime = Math.floor(date?.getTime() / 1000);

        return unixTime;
    } else return
}

export function formatElapsedTimenew(elapsedMs) {
    const hours = Math.floor((elapsedMs / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((elapsedMs / (1000 * 60)) % 60);
    const seconds = Math.floor((elapsedMs / 1000) % 60);

    // Pad hours, minutes, and seconds to always show two digits (e.g., 00:00:09)
    return [
        String(hours).padStart(2, '0'),
        String(minutes).padStart(2, '0'),
        String(seconds).padStart(2, '0')
    ].join(':');
}

export function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/** Local date + 12h time parts for nav/header (date and time on separate lines). */
export function formatNavHeaderLocalDateTimeParts(d = new Date(), options = {}) {
    const { includeSeconds = false } = options;
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    const y = d.getFullYear();
    const mo = d.getMonth() + 1;
    const day = d.getDate();
    let h24 = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    const ampm = h24 >= 12 ? "pm" : "am";
    let h12 = h24 % 12;
    if (h12 === 0) h12 = 12;
    const secondsSuffix = includeSeconds ? `:${pad(s)}` : "";
    return {
        dateLine: `${y}-${pad(mo)}-${pad(day)}`,
        timeLine: `${pad(h12)}:${pad(m)}${secondsSuffix} ${ampm}`,
    };
}

/** Local date + 12h time for nav/header (e.g. 2026-04-04 10:55 pm) */
export function formatNavHeaderLocalDateTime(d = new Date(), options = {}) {
    const { dateLine, timeLine } = formatNavHeaderLocalDateTimeParts(d, options);
    return `${dateLine} ${timeLine}`;
}

/**
 * Parse `dynamic_elements.now_local` from API (e.g. "2026-04-07 07:39:27") to a Date.
 * Uses wall-clock components in the browser's local timezone (same as formatting the label).
 */
export function parsePropertyLocalNowToDate(s) {
    if (s == null || String(s).trim() === '') return null;
    const t = String(s).trim();
    const m = t.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (m) {
        const y = Number(m[1]);
        const mo = Number(m[2]);
        const day = Number(m[3]);
        const h = Number(m[4]);
        const mi = Number(m[5]);
        const se = m[6] != null ? Number(m[6]) : 0;
        const d = new Date(y, mo - 1, day, h, mi, se);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** Persist nav header property-clock anchor across page reloads. */
export const NAV_NOW_LOCAL_ANCHOR_STORAGE_KEY = 'navHeaderNowLocalAnchor';

/** Allow API `now_local` to be slightly behind the ticking clock before treating it as stale. */
const NAV_NOW_LOCAL_STALE_SKEW_MS = 2 * 60 * 1000;

export function formatPropertyNowLocalStorageValue(d) {
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '';
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function readNavNowLocalAnchor() {
    try {
        const v = JSON.parse(localStorage.getItem(NAV_NOW_LOCAL_ANCHOR_STORAGE_KEY) || 'null');
        if (
            v &&
            typeof v.raw === 'string' &&
            Number.isFinite(v.atMs) &&
            Number.isFinite(v.baseTimeMs)
        ) {
            return v;
        }
    } catch {
        /* ignore */
    }
    return null;
}

export function writeNavNowLocalAnchor(anchor) {
    try {
        if (!anchor || typeof anchor.raw !== 'string') {
            localStorage.removeItem(NAV_NOW_LOCAL_ANCHOR_STORAGE_KEY);
            return;
        }
        localStorage.setItem(
            NAV_NOW_LOCAL_ANCHOR_STORAGE_KEY,
            JSON.stringify({
                raw: anchor.raw,
                atMs: anchor.atMs,
                baseTimeMs: anchor.baseTimeMs
            })
        );
    } catch {
        /* ignore */
    }
}

export function clearNavNowLocalAnchor() {
    try {
        localStorage.removeItem(NAV_NOW_LOCAL_ANCHOR_STORAGE_KEY);
    } catch {
        /* ignore */
    }
}

/**
 * Resolve the property-local clock for the nav header.
 * Keeps a monotonic tick across reloads; ignores stale `now_local` rewrites that would jump backward.
 */
export function resolveNavPropertyLocalNow(rawNowLocal, previousAnchor = null) {
    const parsed = parsePropertyLocalNowToDate(rawNowLocal);
    if (!parsed) {
        return {
            displayDate: new Date(),
            anchor: null,
            usedBrowserLocal: true
        };
    }

    const r = String(rawNowLocal);
    const parsedMs = parsed.getTime();
    const nowMs = Date.now();
    let anchor = previousAnchor;

    const isUsableAnchor = (a) =>
        a &&
        typeof a.raw === 'string' &&
        Number.isFinite(a.atMs) &&
        Number.isFinite(a.baseTimeMs);

    if (!isUsableAnchor(anchor)) {
        const persisted = readNavNowLocalAnchor();
        if (isUsableAnchor(persisted)) {
            const currentFromPersisted = persisted.baseTimeMs + Math.max(0, nowMs - persisted.atMs);
            if (persisted.raw === r || parsedMs >= currentFromPersisted - NAV_NOW_LOCAL_STALE_SKEW_MS) {
                if (persisted.raw === r) {
                    anchor = persisted;
                } else {
                    // Fresh-enough API value after reload — resync
                    anchor = { raw: r, atMs: nowMs, baseTimeMs: parsedMs };
                }
            } else {
                // Stale now_local vs persisted tick — keep ticking forward
                anchor = persisted;
            }
        } else {
            anchor = { raw: r, atMs: nowMs, baseTimeMs: parsedMs };
        }
    } else if (anchor.raw !== r) {
        const currentMs = anchor.baseTimeMs + Math.max(0, nowMs - anchor.atMs);
        if (parsedMs >= currentMs - NAV_NOW_LOCAL_STALE_SKEW_MS) {
            anchor = { raw: r, atMs: nowMs, baseTimeMs: parsedMs };
        } else {
            // Ignore stale rewrite; keep times, retag raw so we don't re-evaluate every tick
            anchor = { ...anchor, raw: r };
        }
    }

    const displayDate = new Date(anchor.baseTimeMs + Math.max(0, nowMs - anchor.atMs));
    return {
        displayDate,
        anchor,
        usedBrowserLocal: false
    };
}

/**
 * Write the ticking clock back into userDetailsAll so a hard refresh does not snap to an old login timestamp.
 */
export function syncNavNowLocalIntoUserDetails(displayDate) {
    if (!(displayDate instanceof Date) || Number.isNaN(displayDate.getTime())) return null;
    const nextRaw = formatPropertyNowLocalStorageValue(displayDate);
    try {
        const data = JSON.parse(localStorage.getItem('userDetailsAll') || '{}');
        if (!data || typeof data !== 'object') return null;
        const prev = data?.dynamic_elements?.now_local;
        if (prev === nextRaw) return nextRaw;
        data.dynamic_elements = {
            ...(data.dynamic_elements && typeof data.dynamic_elements === 'object'
                ? data.dynamic_elements
                : {}),
            now_local: nextRaw
        };
        localStorage.setItem('userDetailsAll', JSON.stringify(data));
        return nextRaw;
    } catch {
        return null;
    }
}

/**
 * Map alternate BFF field names onto room rows so the monitor MiniProgressBar
 * (time_start + function_seconds_allocated) receives consistent keys.
 */
function normalizeRoomTimingFields(room) {
    if (!room || typeof room !== 'object') return room;
    const timeStart =
        room.time_start ??
        room.timeStart ??
        room.function_time_start ??
        room.segment_time_start;
    let seconds =
        room.function_seconds_allocated ??
        room.functionSecondsAllocated ??
        room.function_seconds;
    if (seconds == null || seconds === '') {
        seconds = room.cuml_function_seconds_allocated;
    }
    const next = { ...room };
    if (timeStart != null && String(timeStart).trim() !== '') {
        next.time_start = timeStart;
    }
    if (seconds != null && seconds !== '') {
        const n = Number(seconds);
        if (Number.isFinite(n)) next.function_seconds_allocated = n;
    }
    return next;
}

export function convertDataToFloorStructure(data) {
    if (data?.length === 0) {
        return []
    } else {
        const getStatus = (param) => {
            switch (param.toLowerCase()) {
                case 'pending':
                    return '#46BAC7'; // Blue
                case 'checked in today':
                    return '#F1A900'; // Yellow
                case 'dnd':
                    return '#4A4A4A'; // Dark Gray
                case 'dirty':
                    return '#E10171'; // Pink/Red
                case 'clean':
                    return '#06A9F4'; // Blue
                case 'cleaning':
                    return '#06A9F4'; // Blue
                default:
                    return '#CCCCCC'; // Default light gray for unknown status
            }
        };

        // Group data by building + floor so the same floor in different buildings stays separate
        const groupedByBuildingFloor = data?.reduce((acc, room) => {
            const buildingKey = room.buildings_id ?? room.building_name ?? 'default';
            const compositeKey = `${buildingKey}|${room.floor}`;
            if (!acc[compositeKey]) {
                acc[compositeKey] = {
                    buildings_id: room.buildings_id ?? null,
                    building_name: room.building_name ?? null,
                    floor: room.floor,
                    rooms: []
                };
            }
            acc[compositeKey].rooms.push(room);
            return acc;
        }, {});

        // Generate the new structure
        return Object.values(groupedByBuildingFloor)
            .sort((a, b) => {
                const buildingCompare = String(a.building_name || '').localeCompare(
                    String(b.building_name || ''),
                    undefined,
                    { sensitivity: 'base' }
                );
                if (buildingCompare !== 0) return buildingCompare;
                return parseInt(a.floor) - parseInt(b.floor);
            })
            .map(({ buildings_id, building_name, floor, rooms: floorRoomRecords }) => {
                // Group rooms by room_number to consolidate duplicates
                const roomsByNumber = floorRoomRecords.reduce((acc, room) => {
                    const roomKey = room.room_number;
                    if (!acc[roomKey]) {
                        acc[roomKey] = [];
                    }
                    acc[roomKey].push(room);
                    return acc;
                }, {});

                // Consolidate rooms with multiple records
                const consolidatedRooms = Object.keys(roomsByNumber)
                    .sort((a, b) => parseInt(a) - parseInt(b)) // Sort rooms in ascending order
                    .map((roomNumber) => {
                        const roomRecords = roomsByNumber[roomNumber];
                        
                        // If only one record, process normally
                        if (roomRecords.length === 1) {
                            const room = roomRecords[0];
                            const confirmationNumbers = [];
                            
                            // Add confirmation number if it exists
                            if (room.confirmation_number) {
                                confirmationNumbers.push({
                                    confirmation_number: room.confirmation_number,
                                    checkout_today: room.checkout_today || false,
                                    checkin_today: room.checkin_today || false,
                                    ...(room.guest_last != null && room.guest_last !== ''
                                        ? { guest_last: room.guest_last }
                                        : {}),
                                    ...(room.guest_first != null && String(room.guest_first).trim() !== ''
                                        ? { guest_first: room.guest_first }
                                        : {})
                                });
                            }
                            
                            return normalizeRoomTimingFields({
                                ...room,
                                roomNumber: room.room_number,
                                status: room.status_display_text,
                                statusColor: getStatus(room?.clean_state),
                                isDnd: room.inspection_state?.toLowerCase() === 'dnd',
                                confirmation_numbers: confirmationNumbers.length > 0 ? confirmationNumbers : undefined
                            });
                        }
                        
                        // Multiple records - consolidate them
                        // Find primary record (prefer checkout_today=true, otherwise first one)
                        const primaryRecord = roomRecords.find(r => r.checkout_today === true) || roomRecords[0];
                        
                        // Collect all confirmation numbers
                        const confirmationNumbers = [];
                        roomRecords.forEach(record => {
                            if (record.confirmation_number) {
                                confirmationNumbers.push({
                                    confirmation_number: record.confirmation_number,
                                    checkout_today: record.checkout_today || false,
                                    checkin_today: record.checkin_today || false,
                                    ...(record.guest_last != null && record.guest_last !== ''
                                        ? { guest_last: record.guest_last }
                                        : {}),
                                    ...(record.guest_first != null && String(record.guest_first).trim() !== ''
                                        ? { guest_first: record.guest_first }
                                        : {})
                                });
                            }
                        });
                        
                        // Merge properties, prioritizing non-null values from primary record
                        const consolidatedRoom = { ...primaryRecord };
                        
                        // Merge other properties from all records, prioritizing non-null values
                        roomRecords.forEach(record => {
                            Object.keys(record).forEach(key => {
                                if (record[key] !== null && record[key] !== undefined && record[key] !== '') {
                                    if (consolidatedRoom[key] === null || consolidatedRoom[key] === undefined || consolidatedRoom[key] === '') {
                                        consolidatedRoom[key] = record[key];
                                    }
                                }
                            });
                        });

                        // For turnover: if any record has checkin_today or checkout_today, set on consolidated room
                        // (Monitor "Turning Over Today" filters out single-row dual flags unless multiple segments show changeover)
                        const hasCheckoutToday = roomRecords.some(r => r.checkout_today === true);
                        const hasCheckinToday = roomRecords.some(r => r.checkin_today === true);
                        if (hasCheckoutToday) consolidatedRoom.checkout_today = true;
                        if (hasCheckinToday) consolidatedRoom.checkin_today = true;

                        return normalizeRoomTimingFields({
                            ...consolidatedRoom,
                            roomNumber: consolidatedRoom.room_number,
                            status: consolidatedRoom.status_display_text,
                            statusColor: getStatus(consolidatedRoom?.clean_state),
                            isDnd: consolidatedRoom.inspection_state?.toLowerCase() === 'dnd',
                            confirmation_numbers: confirmationNumbers.length > 0 ? confirmationNumbers : undefined
                        });
                    });
                
                return {
                    floor: parseInt(floor),
                    buildings_id,
                    building_name,
                    rooms: consolidatedRooms
                };
            });
    }

}

export function isRoomCleaning(segmentName) {
    const cleaningRegex = /^rooms cleaning/i;
    return cleaningRegex.test(segmentName);
}

// export function getFloorName(number) {

//     // Handle special cases for 11, 12, 13 (11th, 12th, 13th)
//     const remainder = number % 100;
//     if (remainder >= 11 && remainder <= 13) {
//         return number + "th";
//     }

//     // Extract the first digit of the number
//     const firstChar = number.toString().charAt(0);

//     // Apply suffix based on the first character
//     let suffix = "th"; // Default suffix

//     if (firstChar === "1") {
//         suffix = "st";
//     } else if (firstChar === "2") {
//         suffix = "nd";
//     } else if (firstChar === "3") {
//         suffix = "rd";
//     } else if (firstChar === "4") {
//         suffix = "th";
//     } else if (firstChar === "5") {
//         suffix = "th";
//     } else if (firstChar === "6") {
//         suffix = "th";
//     } else if (firstChar === "7") {
//         suffix = "th";
//     } else if (firstChar === "8") {
//         suffix = "th";
//     } else if (firstChar === "9") {
//         suffix = "th";
//     }

//     return number.toString().charAt(0) + suffix + ' Floor';
// }

export function getFloorName(number) {
    // Handle special cases for 11, 12, 13 (11th, 12th, 13th)
    const remainder = number % 100;
    if (remainder >= 11 && remainder <= 13) {
        return number + "th Floor";
    }

    // Determine the suffix based on the last digit
    const lastDigit = number % 10;
    let suffix = "th"; // Default suffix

    if (lastDigit === 1) {
        suffix = "st";
    } else if (lastDigit === 2) {
        suffix = "nd";
    } else if (lastDigit === 3) {
        suffix = "rd";
    }

    return number + suffix + " Floor";
}

/** Normalize /getcartlocation body: array, { cart_location }, or bare object. */
export function parseCartLocationResponse(data) {
    if (Array.isArray(data)) {
        return data[0] || null;
    }
    if (data?.cart_location) {
        return data.cart_location;
    }
    if (data && (data.floor != null || data.room_number != null)) {
        return data;
    }
    return null;
}

export function getFloorNameNew(number) {
    // Extract the floor number (truncate the last two digits)
    const floorNumber = Math.floor(number / 100);

    // Handle special cases for 11, 12, 13 (11th, 12th, 13th)
    const lastTwoDigits = floorNumber % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return `${lastTwoDigits}th Floor (${number})`;
    }

    // Determine the suffix based on the last digit
    const lastDigit = floorNumber % 10;
    let suffix = "th"; // Default suffix

    if (lastDigit === 1) {
        suffix = "st";
    } else if (lastDigit === 2) {
        suffix = "nd";
    } else if (lastDigit === 3) {
        suffix = "rd";
    }

    return `${floorNumber}${suffix} Floor (${number})`;
}


export function showFloor(number) {
    // Extract the floor number (truncate the last two digits)
    const floorNumber = Math.floor(number / 100);

    // Handle special cases for 11, 12, 13 (11th, 12th, 13th)
    const lastTwoDigits = floorNumber % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return `${lastTwoDigits}th Floor`;
    }

    // Determine the suffix based on the last digit
    const lastDigit = floorNumber % 10;
    let suffix = "th"; // Default suffix

    if (lastDigit === 1) {
        suffix = "st";
    } else if (lastDigit === 2) {
        suffix = "nd";
    } else if (lastDigit === 3) {
        suffix = "rd";
    }

    return `${floorNumber}${suffix} Floor`;
}

export function showRoom(number) {
    // Extract the floor number (truncate the last two digits)
    const floorNumber = Math.floor(number / 100);

    // Handle special cases for 11, 12, 13 (11th, 12th, 13th)
    const lastTwoDigits = floorNumber % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return `Room: ${number}`;
    }

    // Determine the suffix based on the last digit
    const lastDigit = floorNumber % 10;
    let suffix = "th"; // Default suffix

    if (lastDigit === 1) {
        suffix = "st";
    } else if (lastDigit === 2) {
        suffix = "nd";
    } else if (lastDigit === 3) {
        suffix = "rd";
    }

    return `${number}`;
}
